/* eslint-disable */
import { Button, Grid, IconButton, Snackbar, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import AddCommentIcon from '@material-ui/icons/AddComment';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { ORDER_API_DATE_FORMAT } from '../../Constants/Order/Order.constants';
import withServices from '../../Contexts/Services/WithServices.context';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_DOCKET_ADD_NOTE, UI_DOCKET_CLOSE_ADD_NOTE } from '../../State/Store/UI/UI.types';
import dateOnly from '../../Support/DateTime/DateOnly/DateTimeDateOnly.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Modal from '../Modal/Modal.component';
import Spinner from '../Spinner/Spinner.component';
import deliveryDocketStyles from './DeliveryDocket.component.styles';

/**
 * DeliveryDocketAddNote
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const DeliveryDocketAddNote = ({ actions, classes, onClose, open, onAdd, docket, services }) => {
  const [noteContent, setNoteContent] = useState(``);
  const [helperText, setHelperText] = useState(`Max 250 characters`);
  const [tooMany, setTooMany] = useState(false);
  const [error, setError] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  /**
   * Updates helper text
   * @param {number} value Number of characters typedin
   * @returns {void} void
   */
  const updateHelperText = (value) => {
    setNoteContent(value);
    setTooMany(value.length > 250);
    setHelperText(`Max 250 characters ${value.length > 250 ? `(${value.length - 250} too many)` : ``}`);
    return;
  };

  /**
   * Closes add note and resets content
   * @returns {void} void
   */
  const onCloseHandler = () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketCloseAddNote`,
        },
      },
      type: UI_DOCKET_CLOSE_ADD_NOTE,
    });
    setNoteContent(``);
    onClose();
    return;
  };

  /**
   * Closes add note and sends note to API
   * @returns {void} void
   */
  const onAddHandler = async () => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketAddNote`,
        },
      },
      type: UI_DOCKET_ADD_NOTE,
    });

    try {
      const date = dateOnly(docket.ticketDate, ORDER_API_DATE_FORMAT);
      const orderCode = docket.orderCode.trim();
      const docketNumber = docket.docketNumber.trim();
      const docketId = `${date}-${orderCode}-${docketNumber}`;
      setIsSaving(true);
      await services.docketService.addNote({ docketId, noteContent });
      onClose();
      setNoteContent(``);
      if (onAdd) {
        onAdd();
      }
      setIsSaving(false);
    } catch (ex) {
      setError({ error: true });
      setIsSaving(false);
    }

    return;
  };

  return (
    <React.Fragment>
      <Snackbar
        action={[
          <IconButton aria-label="Close" className={classes.close} color="inherit" key="close" onClick={() => setError(false)}>
            <CloseIcon />
          </IconButton>,
        ]}
        anchorOrigin={{
          horizontal: `left`,
          vertical: `bottom`,
        }}
        className={classes.snackbar}
        ContentProps={{ classes: { root: classes.error } }}
        message={
          <span className={classes.snackbarMessage} id="client-snackbar">
            <ErrorIcon className={classes.snackbarIcon} />
            An error has occurred. Please try again later.
          </span>
        }
        open={error}
      />
      <Modal
        content={
          <Grid container>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="medium"
                rows="10"
                rowsMax="10"
                multiline
                onChange={(e) => updateHelperText(e.currentTarget.value)}
                autoFocus
                placeholder="Notes are attached to this docket and visible to your team..."
                value={noteContent}
                helperText={helperText}
                error={tooMany}
              />
            </Grid>
          </Grid>
        }
        footer={
          <Grid className={classes.textAlignRight} container justify="flex-end" spacing={2}>
            <Grid item>
              {isSaving ? (
                <Spinner size={20} loaderStyles={classes.spinner} />
              ) : (
                <Button
                  onClick={onAddHandler}
                  disabled={tooMany || isSaving || !noteContent.length}
                  className={classes.button}
                  color="primary"
                  variant="contained"
                >
                  Add
                </Button>
              )}
            </Grid>
            <Grid item>
              <Button className={classes.button} color="primary" disabled={isSaving} onClick={onCloseHandler} variant="outlined">
                Cancel
              </Button>
            </Grid>
          </Grid>
        }
        paperClasses={classes.paperAddNote}
        maxWidth="md"
        icon={<AddCommentIcon />}
        preventFullScreen
        onClose={onCloseHandler}
        open={!!open}
        rightHeading={null}
        title={
          <Grid container>
            <Grid item xs={12}>
              Add A Note
            </Grid>
          </Grid>
        }
      />
    </React.Fragment>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
DeliveryDocketAddNote.propTypes = {
  docket: PropTypes.any.isRequired,
  actions: PropTypes.object.isRequired,
  services: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onAdd: PropTypes.func,
  open: PropTypes.any.isRequired,
};

export default compose(
  withServices,
  connect(
    null,
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(deliveryDocketStyles), { withTheme: true }),
)(DeliveryDocketAddNote);
